import React, { useState, useEffect } from 'react';
import AgentScene3D from './AgentScene3D';
import GameHUD from './GameHUD';

export default function RPG3DView() {
  const [selectedAgentId, setSelectedAgentId] = useState('peter');
  
  useEffect(() => {
    console.log('RPG3DView mounted - Three.js scene active');
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      {/* Debug Badge */}
      <div style={{ 
        position: 'absolute', 
        top: 10, 
        left: 10, 
        zIndex: 1001, 
        color: '#D4AF37', 
        background: 'rgba(0,0,0,0.8)', 
        padding: '10px', 
        borderRadius: '8px',
        fontWeight: 'bold'
      }}>
        🎮 3D RPG View Active v2.0
      </div>
      
      {/* 3D Scene */}
      <AgentScene3D
        selectedAgentId={selectedAgentId}
        onSelectAgent={setSelectedAgentId}
      />
      
      {/* GameHUD Overlay */}
      <GameHUD selectedAgentId={selectedAgentId} onSelectAgent={setSelectedAgentId} />
    </div>
  );
}
